import likeSvg from '@/assets/img/useful-materials/like-icon.svg'
import viewSvg from '@/assets/img/useful-materials/view-icon.svg'
import saveSvg from '@/assets/img/useful-materials/save-icon.svg'

export const newsBannerTags = ["Мегамикс", "Агрос", "комбикорм", "фермерам", "28.06.2023"]

export const newsSliderSettings = [
    {
        className: "categories-slider",
        big_screen: 5,
        desktop: 4,
        preTablet: 4,
        tablet: {
            slides: 3,
            space: 12
        },
        preMobile: 3,
        mobile: {
            slides: 2,
            initialSlide: 0,
            space: 8
        }
    }
]

export const updatedNews = [
    {
        id: 1,
        title: "Title",
        description: "Description",
        views: 15,
        creation_date: '28.08.08',
        responsible_id: 3,
        card_id: [1, 2, 3],
        photos: ['1', '2', '3'],
        videos: '22222',
        tags_id: [
            {
                id: 1,
                title: 'Megamix',
                value: 'Megamix'
            }
            ,
            {
                id: 2,
                title: 'Agro',
                value: 'Agro'
            },
            {
                id: 3,
                title: 'Press-release',
                value: 'Press-release'
            }
        ],
        preview: 'string',
        intro: 'string',
        products_id: [1, 2, 3, 4, 5]
    },
    {
        id: 2,
        title: "Title",
        description: "Description",
        views: 15,
        creation_date: '28.08.08',
        responsible_id: 3,
        card_id: [1, 2, 3],
        photos: ['1', '2', '3'],
        videos: '22222',
        tags_id: [
            {
                id: 1,
                title: 'Megamix',
                value: 'Megamix'
            }
            ,
            {
                id: 2,
                title: 'Agro',
                value: 'Agro'
            },
            {
                id: 3,
                title: 'Press-release',
                value: 'Press-release'
            }
        ],
        preview: 'string',
        intro: 'string',
        products_id: [1, 2, 3, 4, 5]
    },
    {
        id: 3,
        title: "Title",
        description: "Description",
        views: 15,
        creation_date: '28.08.08',
        responsible_id: 3,
        card_id: [1, 2, 3],
        photos: ['1', '2', '3'],
        videos: '22222',
        tags_id: [
            {
                id: 1,
                title: 'Megamix',
                value: 'Megamix'
            }
            ,
            {
                id: 2,
                title: 'Agro',
                value: 'Agro'
            },
            {
                id: 3,
                title: 'Press-release',
                value: 'Press-release'
            }
        ],
        preview: 'string',
        intro: 'string',
        products_id: [1, 2, 3, 4, 5]
    },
    {
        id: 4,
        title: "Title",
        description: "Description",
        views: 15,
        creation_date: '28.08.08',
        responsible_id: 3,
        card_id: [1, 2, 3],
        photos: ['1', '2', '3'],
        videos: '22222',
        tags_id: [
            {
                id: 1,
                title: 'Megamix',
                value: 'Megamix'
            }
            ,
            {
                id: 2,
                title: 'Agro',
                value: 'Agro'
            },
            {
                id: 3,
                title: 'Press-release',
                value: 'Press-release'
            }
        ],
        preview: 'string',
        intro: 'string',
        products_id: [1, 2, 3, 4, 5]
    },
    {
        id: 5,
        title: "Title",
        description: "Description",
        views: 15,
        creation_date: '28.08.08',
        responsible_id: 3,
        card_id: [1, 2, 3],
        photos: ['1', '2', '3'],
        videos: '22222',
        tags_id: [
            {
                id: 1,
                title: 'Megamix',
                value: 'Megamix'
            }
            ,
            {
                id: 2,
                title: 'Agro',
                value: 'Agro'
            },
            {
                id: 3,
                title: 'Press-release',
                value: 'Press-release'
            }
        ],
        preview: 'string',
        intro: 'string',
        products_id: [1, 2, 3, 4, 5]
    },
    {
        id: 6,
        title: "Title",
        description: "Description",
        views: 15,
        creation_date: '28.08.08',
        responsible_id: 3,
        card_id: [1, 2, 3],
        photos: ['1', '2', '3'],
        videos: '22222',
        tags_id: [
            {
                id: 1,
                title: 'Megamix',
                value: 'Megamix'
            }
            ,
            {
                id: 2,
                title: 'Agro',
                value: 'Agro'
            },
            {
                id: 3,
                title: 'Press-release',
                value: 'Press-release'
            }
        ],
        preview: 'string',
        intro: 'string',
        products_id: [1, 2, 3, 4, 5]
    },
    {
        id: 7,
        title: "Title",
        description: "Description",
        views: 15,
        creation_date: '28.08.08',
        responsible_id: 3,
        card_id: [1, 2, 3],
        photos: ['1', '2', '3'],
        videos: '22222',
        tags_id: [
            {
                id: 1,
                title: 'Megamix',
                value: 'Megamix'
            }
            ,
            {
                id: 2,
                title: 'Agro',
                value: 'Agro'
            },
            {
                id: 3,
                title: 'Press-release',
                value: 'Press-release'
            }
        ],
        preview: 'string',
        intro: 'string',
        products_id: [1, 2, 3, 4, 5]
    },
    {
        id: 8,
        title: "Title",
        description: "Description",
        views: 15,
        creation_date: '28.08.08',
        responsible_id: 3,
        card_id: [1, 2, 3],
        photos: ['1', '2', '3'],
        videos: '22222',
        tags_id: [
            {
                id: 1,
                title: 'Megamix',
                value: 'Megamix'
            }
            ,
            {
                id: 2,
                title: 'Agro',
                value: 'Agro'
            },
            {
                id: 3,
                title: 'Press-release',
                value: 'Press-release'
            }
        ],
        preview: 'string',
        intro: 'string',
        products_id: [1, 2, 3, 4, 5]
    },
    {
        id: 9,
        title: "Title",
        description: "Description",
        views: 15,
        creation_date: '28.08.08',
        responsible_id: 3,
        card_id: [1, 2, 3],
        photos: ['1', '2', '3'],
        videos: '22222',
        tags_id: [
            {
                id: 1,
                title: 'Megamix',
                value: 'Megamix'
            }
            ,
            {
                id: 2,
                title: 'Agro',
                value: 'Agro'
            },
            {
                id: 3,
                title: 'Press-release',
                value: 'Press-release'
            }
        ],
        preview: 'string',
        intro: 'string',
        products_id: [1, 2, 3, 4, 5]
    },
    {
        id: 10,
        title: "Title",
        description: "Description",
        views: 15,
        creation_date: '28.08.08',
        responsible_id: 3,
        card_id: [1, 2, 3],
        photos: ['1', '2', '3'],
        videos: '22222',
        tags_id: [
            {
                id: 1,
                title: 'Megamix',
                value: 'Megamix'
            }
            ,
            {
                id: 2,
                title: 'Agro',
                value: 'Agro'
            },
            {
                id: 3,
                title: 'Press-release',
                value: 'Press-release'
            }
        ],
        preview: 'string',
        intro: 'string',
        products_id: [1, 2, 3, 4, 5]
    },
    {
        id: 11,
        title: "Title",
        description: "Description",
        views: 15,
        creation_date: '28.08.08',
        responsible_id: 3,
        card_id: [1, 2, 3],
        photos: ['1', '2', '3'],
        videos: '22222',
        tags_id: [
            {
                id: 1,
                title: 'Megamix',
                value: 'Megamix'
            }
            ,
            {
                id: 2,
                title: 'Agro',
                value: 'Agro'
            },
            {
                id: 3,
                title: 'Press-release',
                value: 'Press-release'
            }
        ],
        preview: 'string',
        intro: 'string',
        products_id: [1, 2, 3, 4, 5]
    },
    {
        id: 12,
        title: "Title",
        description: "Description",
        views: 15,
        creation_date: '28.08.08',
        responsible_id: 3,
        card_id: [1, 2, 3],
        photos: ['1', '2', '3'],
        videos: '22222',
        tags_id: [
            {
                id: 1,
                title: 'Megamix',
                value: 'Megamix'
            }
            ,
            {
                id: 2,
                title: 'Agro',
                value: 'Agro'
            },
            {
                id: 3,
                title: 'Press-release',
                value: 'Press-release'
            }
        ],
        preview: 'string',
        intro: 'string',
        products_id: [1, 2, 3, 4, 5]
    },
]

export const newsCardList = [
    {
        id: "1",
        image_url: "https://s3-alpha-sig.figma.com/img/6cc0/980f/a25d302a5742d2b3ec8b6a07aa277acd?Expires=1699228800&Signature=n-nY~f5kUfy4vZZvsQjT5ztEK48INyfTYWzLvVhqMJ7znXJxkk6wIwyXCtOVJZB9uMgz-4YVzhj~OFiScnWzR8Lml32j0oxxbT4yA12RVYj4UhmWSpHNTTG--zXWevCgGZIBri~vtlZrK9bbDZmvbsl2NDadQs6aO8yLdoXl3Ilga-x6krP8lOmWDTAUWnHd30i6d3xa1SyZI5f20xxgCqtzIsApvtx9T4XkJZMZ~31AAtb1oQlKqBbSwSxpZHZzT774wLkPp0vLe9rKjmB1HcwYecC7J2m~23PBPMfhsXrHeZAsIdtLXrR7~9UPcmpAJxpDAwjEUbLfzqxP59u3og__&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4",
        tags: ["пресс-релиз", "Мегамикс", "28.06.2023"],
        title: "ГК МЕГАМИКС на Агрос 2023",
        text: "МегаМикс, ведущий производитель кормов и решений для животноводства, рад представить яркие впечатления с Международной выставки Агрос, которая проходила с 25 по 27 января 2023 года в Москве. Это важное мероприятие для сельскохозяйственной отрасли собрало профессионалов из области племенного дела, ветеринарии и технологий для животноводства, свиноводства, птицеводства и кормопроизводства.",
    },
    {
        id: "2",
        image_url: "https://s3-alpha-sig.figma.com/img/1172/4c57/46e5a4279f04bcf3c1a2e20d35f0f3f8?Expires=1699228800&Signature=YwwvJavERCe4IKRX7ydmZlpEwxQOB2Xcho-i0taRvpDdIQCeHgJXID~j-IWG77dPR9NTPzO7QIuFZ1vOlBqNznFN1rSmjain~2k2yRdxHg~sZE5m-DfcpaSdxaSlol-MwdafBtMRaCpII90ikzHl~9pCzt-2ZxoIBE9e0EOjk-93M6gksIpyKRgx50NBC69HmxE7-2Z9r3Zik3x1AICzL6gq2CHmOWcgRJXDgT3yZqhGJU4CaZix0q5BQCMymrtAzLJVi88103ULcFp58u9FRoFt2-BLQbbHMDJqPByc2rPvbjJnIM-xRvZuZinrKzSpOXTx15Dpg6AG6DlE4uI~jw__&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4",
        tags: ["пресс-релиз", "Мегамикс", "28.06.2023"],
        title: "ГК МЕГАМИКС на Агрос 2023",
        text: "МегаМикс, ведущий производитель кормов и решений для животноводства, рад представить яркие впечатления с Международной выставки Агрос, которая проходила с 25 по 27 января 2023 года в Москве. Это важное мероприятие для сельскохозяйственной отрасли собрало профессионалов из области племенного дела, ветеринарии и технологий для животноводства, свиноводства, птицеводства и кормопроизводства.",
    },
    {
        id: "3",
        image_url: "https://s3-alpha-sig.figma.com/img/cf47/01d2/502d704de16793beeced2cc5e5ed93fe?Expires=1699228800&Signature=LnT3bwqLUcQkvm8nahYPK4WsVeE46PcT-KLlsJxIVafkNGnlRh1-OhA5k8hm0cvIyzySJh2M0B2wZYeGrkb10-uTQU1MmERK2JWNpGW4VmV3aBHgwGhUWWwWZk~seqB9L54UaE~WmC~Eu6VF-ioeS1we-XPpTMyMBrHaxDUIkAqHPA9EozeK2q-NsSMnoRlIYZAqsMQ80GptEFpaaJVUlPvFzjWXLIQxHe9qFnBSIJ92kVzzD6hSqY6yxoUea3y2Y3fma-kbmZdttYEPq3IIqjS9fWtymXZrgqoztr29po45tfQZMdpS~yUUhbhLjAzwY0DnevOVmjDaLaaUB05ssw__&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4",
        tags: ["пресс-релиз", "Мегамикс", "28.06.2023"],
        title: "ГК МЕГАМИКС на Агрос 2023",
        text: "МегаМикс, ведущий производитель кормов и решений для животноводства, рад представить яркие впечатления с Международной выставки Агрос, которая проходила с 25 по 27 января 2023 года в Москве. Это важное мероприятие для сельскохозяйственной отрасли собрало профессионалов из области племенного дела, ветеринарии и технологий для животноводства, свиноводства, птицеводства и кормопроизводства.",
    },
    {
        id: "4",
        image_url: "https://s3-alpha-sig.figma.com/img/cf47/01d2/502d704de16793beeced2cc5e5ed93fe?Expires=1699228800&Signature=LnT3bwqLUcQkvm8nahYPK4WsVeE46PcT-KLlsJxIVafkNGnlRh1-OhA5k8hm0cvIyzySJh2M0B2wZYeGrkb10-uTQU1MmERK2JWNpGW4VmV3aBHgwGhUWWwWZk~seqB9L54UaE~WmC~Eu6VF-ioeS1we-XPpTMyMBrHaxDUIkAqHPA9EozeK2q-NsSMnoRlIYZAqsMQ80GptEFpaaJVUlPvFzjWXLIQxHe9qFnBSIJ92kVzzD6hSqY6yxoUea3y2Y3fma-kbmZdttYEPq3IIqjS9fWtymXZrgqoztr29po45tfQZMdpS~yUUhbhLjAzwY0DnevOVmjDaLaaUB05ssw__&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4",
        tags: ["пресс-релиз", "Мегамикс", "28.06.2023"],
        title: "ГК МЕГАМИКС на Агрос 2023",
        text: "МегаМикс, ведущий производитель кормов и решений для животноводства, рад представить яркие впечатления с Международной выставки Агрос, которая проходила с 25 по 27 января 2023 года в Москве. Это важное мероприятие для сельскохозяйственной отрасли собрало профессионалов из области племенного дела, ветеринарии и технологий для животноводства, свиноводства, птицеводства и кормопроизводства.",
    },
    {
        id: "5",
        image_url: "https://s3-alpha-sig.figma.com/img/6cc0/980f/a25d302a5742d2b3ec8b6a07aa277acd?Expires=1699228800&Signature=n-nY~f5kUfy4vZZvsQjT5ztEK48INyfTYWzLvVhqMJ7znXJxkk6wIwyXCtOVJZB9uMgz-4YVzhj~OFiScnWzR8Lml32j0oxxbT4yA12RVYj4UhmWSpHNTTG--zXWevCgGZIBri~vtlZrK9bbDZmvbsl2NDadQs6aO8yLdoXl3Ilga-x6krP8lOmWDTAUWnHd30i6d3xa1SyZI5f20xxgCqtzIsApvtx9T4XkJZMZ~31AAtb1oQlKqBbSwSxpZHZzT774wLkPp0vLe9rKjmB1HcwYecC7J2m~23PBPMfhsXrHeZAsIdtLXrR7~9UPcmpAJxpDAwjEUbLfzqxP59u3og__&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4",
        tags: ["пресс-релиз", "Мегамикс", "28.06.2023"],
        title: "ГК МЕГАМИКС на Агрос 2023",
        text: "МегаМикс, ведущий производитель кормов и решений для животноводства, рад представить яркие впечатления с Международной выставки Агрос, которая проходила с 25 по 27 января 2023 года в Москве. Это важное мероприятие для сельскохозяйственной отрасли собрало профессионалов из области племенного дела, ветеринарии и технологий для животноводства, свиноводства, птицеводства и кормопроизводства.",
    },
    {
        id: "6",
        image_url: "https://s3-alpha-sig.figma.com/img/d70a/0546/edd3a8b468b83f23ea33feef1763dd76?Expires=1699228800&Signature=OPy1kYLHwpvagSLrw8MzLN7s5S7OwSyv2rIiA0oR1Esdj9IAGvCp-gCE4UEX7ROEJJwHCZGM1raaDjGgnEdJMjx-p4iOpqKpvC8vFkkszLyGyouOBvCOQXg~rwuwzvPIf-0zL6ug5fqBmw0j5-M~bERLwGX22cJjn4m9897R5GaLjl5njJLygbkueYTwWSDPHWLc6UE5ux8LmDWEJ8hwdtF5EEuVhAP3HHkqK~Ne2Mr~FrBWjhazdTIBXeWuRwgzIYbPUEMzqxFFwT0ce4LfYx9m68UdYDh7-ieT2cqZg-mw18djoiYL1PjfjLLZP5MfxxLIhCPmXRP39xzQKh0b3w__&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4",
        tags: ["пресс-релиз", "Мегамикс", "28.06.2023"],
        title: "ГК МЕГАМИКС на Агрос 2023",
        text: "МегаМикс, ведущий производитель кормов и решений для животноводства, рад представить яркие впечатления с Международной выставки Агрос, которая проходила с 25 по 27 января 2023 года в Москве. Это важное мероприятие для сельскохозяйственной отрасли собрало профессионалов из области племенного дела, ветеринарии и технологий для животноводства, свиноводства, птицеводства и кормопроизводства.",
    },
]

export const newsStats = [
    {
        image: viewSvg,
        text: "40 k"
    },
    {
        image: likeSvg,
        text: "17"
    },
    {
        image: saveSvg,
        text: "17"
    },
]

export const newsBannerSide = [
    {
        title: "ГК МЕГАМИКС на Агрос 2023",
        tags: [
            "пресс-релиз",
            "МегаМикс",
            "Агрос",
            "28.06.2023"
        ]
    },
    {
        title: "Команда МегаМикс на выставке «Татагроэкспо»",
        tags: [
            "пресс-релиз",
            "МегаМикс",
            "Агрос",
            "28.06.2023"
        ]
    },
    {
        title: "Презентация Слушкова В.П. «Экономическое обоснование программы выращивания молодняка КРС»",
        tags: [
            "пресс-релиз",
            "МегаМикс",
            "Агрос",
            "28.06.2023"
        ]
    },
    {
        title: "Мегамикс запускает производство кормов для рыб",
        tags: [
            "пресс-релиз",
            "МегаМикс",
            "Агрос",
            "28.06.2023"
        ]
    }
]